import FindTheLetter from './findTheLetter';
import FindTheObjects from './findTheObjects';
import SoundOutWords from './soundOutWords';
import FindTheLetterStudent from './findTheLetterStudent';
import FindTheObjectsStudent from './findTheObjectsStudent';

const activitiesQueries = {
  FindTheLetter,
  FindTheObjects,
  SoundOutWords,
  FindTheLetterStudent,
  FindTheObjectsStudent,
};

export default activitiesQueries;
